import { HttpClient } from './HttpClient';

export const http = new HttpClient({
    baseURL: process.env.REACT_APP_BASE_URL,
});
